export const _getTutoringSubjectDetails = (state, action) => action.payload;